import { IcChevronLeft, Text } from 'basic-ui-lib';
import { BreadcrumbPath } from 'modules/media/services/hooks/useMediaExplorer';
import styled from 'styled-components';

interface BreadcrumbProps {
  path: BreadcrumbPath[];
  onBack: () => void;
}

export const Breadcrumb = ({
  path,
  onBack,
}: BreadcrumbProps) => {

  if (path.length === 0) return null;

  const current = path[path.length - 1];

  return (
    <Container>
      <button onClick={onBack} style={{ background: 'none', border: 'none' }} type='button'>
        <IcChevronLeft width={24} height={24} />
      </button>
      <Text title_h7 medium>
        {current.label}
      </Text>
    </Container>
  );
};


const Container = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  gap: 16px;
`;